// Zdroj pravdy pro zobrazovaný text u větrné růžice. Klient ze serveru čte jen
// syrové id (směr "01".."16", interval "01".."04"/vtype+"_NN") a název/popisek
// si mapuje vždy odsud — ne z directions[].name / series[].label z API, viz
// doc/plans/windrose-report.md sekce 3.

export const WIND_SPEED_INTERVALS = {
  '01': '1 m/s',
  '02': '2–4 m/s',
  '03': '5–9 m/s',
  '04': '> 9 m/s',
}

export const DIRS_R08 = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
export const DIRS_R16 = [
  'N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE',
  'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW',
]

export function dirsForVtype(vtype) {
  return vtype === 'R08' ? DIRS_R08 : DIRS_R16
}
